// @flow
import React from 'react';

import Product from './Product';
import Notification from './Notification';

class ProductPage extends React.Component {
	render() {
		return (
			<div id="product_content">
				<Notification />
				<Product />
			</div>
		);
	}
}

export default ProductPage;
